<template>
  <div v-bar class="vs-scrollable" style="line-height: 2.45; display: flex;">
    <div>
      <div class="con-exemple-customer-prompt px-4 py-3">

        <vs-row>
          <h3>
            <br />
            Translations
          </h3>
        </vs-row>
        <vs-row>
          <vs-input
            :danger="errors.selected.firstName"
            :danger-text="
              $t('Errors.InvalidPolite', { field: $t('Service.Table.Title') })
            "
            label="en"
            v-model="selectedRegion.translations.en"
            class="w-100 mb-2"
          />
        </vs-row>
        <vs-row>
          <vs-input
            :danger="errors.selected.firstName"
            :danger-text="
              $t('Errors.InvalidPolite', { field: $t('Service.Table.Title') })
            "
            label="fr"
            v-model="selectedRegion.translations.fr"
            class="w-100 mb-2"
          />
        </vs-row>

        <vs-row>
          <vs-input
            :danger="errors.selected.firstName"
            :danger-text="
              $t('Errors.InvalidPolite', { field: $t('Service.Table.Title') })
            "
            label="ar"
            v-model="selectedRegion.translations.ar"
            class="w-100 mb-2"
          />
        </vs-row>

        <vs-row>
          <vs-input
            :danger="errors.selected.firstName"
            :danger-text="
              $t('Errors.InvalidPolite', { field: $t('Service.Table.Title') })
            "
            label="de"
            v-model="selectedRegion.translations.de"
            class="w-100 mb-2"
          />
        </vs-row>

        <vs-row>
          <vs-input
            :danger="errors.selected.firstName"
            :danger-text="
              $t('Errors.InvalidPolite', { field: $t('Service.Table.Title') })
            "
            label="es"
            v-model="selectedRegion.translations.es"
            class="w-100 mb-2"
          />
        </vs-row>

        <vs-col vs-w="12" class="text-right mt-4">
          <vs-button
            @click="updateRegion()"
            color="warning"
            class="pr-5 pl-5 float-right"
          >
            {{ $t("Region.UpdateButton") }}
          </vs-button>
        </vs-col>
      </div>
    </div>
  </div>
</template>

<script>
import { regionServices } from "../../_services";
export default {
  name: "UpdateRegion",
  data: () => ({
    errors: {
            firstName: false,
            lastName: false,
            email: false,
            phoneNumber: false,
            libID: false,
            selected: {
                firstName: false,
                lastName: false,
                email: false,
                phoneNumber: false,
                libID: false
      }
    }
  }),
  props: {
    selectedRegion: Object,
  },
  methods: {
    notify(name, text, type) {
      this.$vs.notify({
        color: type,
        name: name,
        text: text,
      });
    },
    hide() {
      this.$emit("hide", "hide");
    },
    reloadData() {
      this.$emit("reloadData", "reloadData");
    },
    updateRegion() {
      let payload = {
        name: JSON.stringify(this.selectedRegion.translations),
      };
      this.showLoading();
      regionServices
        .update(this.selectedRegion.id, payload)
        .then(
          () => {
            this.reloadData();
            this.hide();
            this.notify(
              this.$t("Toasts.Successful"),
              "Service Created",
              "success"
            );
          }
        )
        .catch(
          (err) => {
            console.log(err)
            this.notify(
              this.$t("Toasts.Error"),
              this.$t("Customer.EditCustomerPrompt.ToastFailMessage"),
              "danger"
            );
          }
        )
        .finally(
          () => {
            this.hideLoading();
          }
        );
    },
    showLoading() {
      this.$vs.loading({
        container: "#regions-page",
        scale: 0.6,
      });
    },
    hideLoading() {
      this.$vs.loading.close("#regions-page > .con-vs-loading");
    },
  },
  mounted() {},
};
</script>
